import { createTicketRequest, addMessageRequest } from "../ticketApi";
import { createTicket } from "../ticketList/ticketListSlice";
import { addMessage } from "../ticketMessages/ticketMessagesReducer";

export const createNewTicketThunk = (ticketBody) => {
  return async (dispatch) => {
    const response = await createTicketRequest(ticketBody);
    dispatch(createTicket(response.data));
    return response;
  };
};

export const addNewMessageThunk = ({ id, content, attachments }) => {
  return async (dispatch) => {
    const response = await addMessageRequest(id, content, attachments);
    dispatch(addMessage(response.data));
    return response;
  };
};
